import {
  ChartMark,
  WidgetKind,
  type Filters,
  type Report,
} from 'corso-admin-ui';
import { byFinalizedDay, topProducts } from '../claimItems';

const shopNowItems = { isShopNow: true } satisfies Filters<'claimItems'>;
// claim-level: a claim that mixes Shop Now with other lines counts whole
const shopNowClaims = { hasShopNow: true } satisfies Filters<'claims'>;
const finalizedShopNowClaims = {
  description: byFinalizedDay,
  filters: shopNowClaims,
  dataset: 'claims',
  timeField: 'finalizedOn',
} as const;

export const shopNow = {
  key: 'shopNow',
  label: 'Shop Now',
  dataset: 'claimItems',
  timeFields: ['finalizedOn'],
  widgets: [
    {
      kind: WidgetKind.kpi,
      title: 'Shop Now requests',
      metric: 'claims',
      filters: shopNowItems,
    },
    {
      kind: WidgetKind.kpi,
      title: 'Items returned for Shop Now credit',
      metric: 'items',
      filters: shopNowItems,
    },
    {
      kind: WidgetKind.kpi,
      title: 'Retained revenue on Shop Now requests',
      metric: 'retainedRevenue',
      ...finalizedShopNowClaims,
    },
    {
      kind: WidgetKind.kpi,
      title: 'New revenue on Shop Now requests',
      metric: 'newRevenue',
      ...finalizedShopNowClaims,
    },
    {
      kind: WidgetKind.kpi,
      metric: 'shopNowIncentives',
      ...finalizedShopNowClaims,
    },
    {
      kind: WidgetKind.overTime,
      title: 'Items returned for Shop Now credit',
      mark: ChartMark.bar,
      metrics: ['items'],
      filters: shopNowItems,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Credit chosen before shopping',
      dimension: 'creditResolution',
      metric: 'claims',
      ...finalizedShopNowClaims,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Top reasons',
      dimension: 'reason',
      metric: 'items',
      filters: shopNowItems,
      limit: 10,
    },
    { ...topProducts, filters: shopNowItems },
  ],
} as const satisfies Report;
